import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import UserForm from '../../../components/forms/UserForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import PostAction from '../../../actions/users/PostAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class CreateUserPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.error
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Utilisateur ajouté.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.post(data)
  }

  render() {
    return (
      <Popup
        header='Créer un utilisateur'
        body={
          <UserForm
            data={undefined}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={false}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.error}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Créer',
            color: 'green',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isSaving={this.props.isSaving}
      />
    )
  }
}

CreateUserPopup.propTypes = {
  // Properties
  onClose: PropTypes.func.isRequired,

  // Redux State
  isSaving: PropTypes.bool.isRequired,
  error: PropTypes.object,

  // Redux Actions
  post: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    isSaving: state.entities.users.post.isFetching,
    error: state.entities.users.post.error
  }),
  (dispatch) => ({
    post: (data) => (dispatch(PostAction({ data }))),
    clearError: () => (dispatch(ClearErrorAction(Types.USERS.POST)))
  })
)(CreateUserPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/users/CreateUserPopup.js